export const download = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    if (filename)
        link.download = filename;
    link.click();
    link.remove();
};
